// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/BlueCardReport/BlueCardReportView/BlueCardHeader/BllueCardHeader.css
// module id = 2268
// module chunks = 0